module.exports = __webpack_public_path__ + "static/mentor-sumeer-walia_s-db9f4659f3672575beaf7928dff8f6c1.jpg";